import { useDispatch } from 'react-redux';

import { DealProduct } from '../types';
import Alert from '../../../shared/components/Alert/Alert';
import { updateDealProductQuantity } from '../slice';
import { useAppSelector } from '../../../shared/store';

export default function useDealProduct(dealProduct: DealProduct) {
  const { contentType } = useAppSelector(({ productDetail }) => productDetail);

  const { no, name, maxEa, minEa } = dealProduct;

  const dispatch = useDispatch();

  const changeQuantity = (newQuantity: number) => {
    if (maxEa < newQuantity) {
      Alert({
        title: '알림',
        text: `${name} 상품의 \n최대 구매 수량은 ${maxEa}개 입니다.`,
      });
      return;
    }

    const minQuantity = newQuantity < minEa ? minEa : newQuantity;
    const quantity = contentType === 'MULTI' ? newQuantity : minQuantity;

    dispatch(
      updateDealProductQuantity({
        targetProductNo: no,
        quantity,
      }),
    );
  };

  const deselect = () => {
    dispatch(
      updateDealProductQuantity({
        targetProductNo: no,
        quantity: 0,
      }),
    );
  };

  return { changeQuantity, deselect };
}
